import { listen, qs, qsa } from '@fluorescent/dom';

import { section } from '@/glow';
import { on, emit } from '@/glow/events';
import Navigation from '@/lib/header/navigation';
import QuickSearch from '@/components/quick-search';
import QuickCart from '@/lib/header/quick-cart';
import StickyHeader from '@/lib/sticky-header';
import DrawerMenu from '@/lib/drawer-menu';

const selectors = {
  jsCartCount: '.js-cart-count',
  jsCartToggle: '.js-cart-drawer-toggle',
};

section('header', {
  onLoad() {
    this.menuButton = qs('#mobile-nav', this.container);
    this.quickSearch = QuickSearch(qs('.quick-search', this.container));
    this.quickCart = QuickCart(qs('[data-quick-cart]', this.container));
    this.stickyHeader = StickyHeader(qs('[data-sticky-header]', document));
    this.drawerMenu = DrawerMenu(qs('[data-drawer-menu]', this.container));
    const cartCount = qs(selectors.jsCartCount, this.container);
    const cartToggles = qsa(selectors.jsCartToggle, this.container);

    this.desktopNav = new Navigation(this.container);

    listen(this.menuButton, 'click', this.drawerMenu.open);

    on('cart:updated', state => {
      cartCount.innerHTML = state.cart.item_count;
    });

    cartToggles.forEach(toggle => {
      listen(toggle, 'click', e => {
        e.preventDefault();

        emit('cart:toggle', state => {
          return {
            cartOpen: !state.cartOpen,
          };
        });
      });
    });
  },

  onSelect() {
    emit('sticky-header:reload', () => {});
  },

  onUnload() {
    this.quickSearch.unload();
    this.stickyHeader.unload();
    this.drawerMenu.unload();
  },
});
